import Divider from '@material-ui/core/Divider';
import { CheckboxGroup, InputCheckbox } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

function TreeViewSelected({ selected, setSelected }) {
  const { t } = useTranslation(['general']);

  function getChecked(item) {
    return !!selected.find((element) => element && element.guid === item.guid);
  }

  function onChange(event, item) {
    const checked = event.target.checked;
    const newSelected = checked ? [...selected, item] : selected.filter((element) => element.guid !== item.guid);

    setSelected(newSelected);
  }

  return (
    <CheckboxGroup isLegendHidden legend={t('general:selected')}>
      {selected.map((item) => {
        const key = item.guid ? item.guid : item;

        return (
          <div key={key} className="tree-view-selected">
            <div className="tree-view-selected__item">
              <InputCheckbox checked={getChecked(item)} onChange={(event) => onChange(event, item)} label={item.name} subtitle={item.description} />
            </div>

            <Divider />
          </div>
        );
      })}
    </CheckboxGroup>
  );
}

TreeViewSelected.propTypes = {
  selected: PropTypes.array,
  setSelected: PropTypes.func,
};

TreeViewSelected.defaultProps = {
  selected: [],
  setSelected: () => {},
};

export default TreeViewSelected;
